import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/eye-slash': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M272.7 359.1C192.2 350.1 136.5 272.3 155.8 192.1L272.7 359.1zM288 392C185.4 392 95.9 337.3 48 256 69.8 219.1 100.1 187.7 136.3 164.3L108.8 125C67 152.2 31.9 188.7 6.6 231.6A48-48 0 0 1 6.6 280.4C63 376 168.1 440 288 440A332.9-332.9 0 0 1 327.6 437.6L295.6 391.9A284.2-284.2 0 0 0 288 392zM569.4 280.4C536.1 336.8 485.9 382.1 425.8 409.9L473.9 478.6C477.7 484 476.4 491.5 471 495.3L450.2 509.8C444.8 513.6 437.3 512.3 433.5 506.9L102.1 33.4C98.3 28 99.6 20.5 105 16.7L125.8 2.2C131.2-1.6 138.7-0.3 142.5 5.1L198 84.4C226.6 76.3 256.8 72 288 72 407.9 72 513 136 569.4 231.6A48-48 0 0 0 569.4 280.4zM528 256C483.8 181.1 404.3 128.7 311.8 121 302 131.1 296 144.8 296 160 296 190.9 321.1 216 352 216S408 190.9 408 160L408 160C438.6 217.2 424.7 290.2 371.1 331.7L397.8 369.8C452.6 346.6 498.3 306.4 528 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/eye-slash.js
// module id = BVeC
// module chunks = 144